
import React from "react";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import DestinosPrimariosSeleccion from "../components/destinos/destinosPrimariosSeleccion";

export default function Primarios() {
    return (
        <Layout>
          <Navbar darkBg />
          <PageHeader
            HeaderTitle="Destino Primarios"
            Parent="Destino"
            PageTitle="Primarios"
          />
          <DestinosPrimariosSeleccion hasTitle />
          <Footer />
        </Layout>
      );
}